import { Component, ViewChild, OnInit } from '@angular/core';
import { ValueTypeService } from '@app/services/valueType/valuetype.service';
import { AcquirerOutlet } from '@app/models/merchant/AcquirerModel';

@Component({
    selector: 'app-outlets',
    templateUrl: './outlets.component.html',
    styleUrls: ['../pre-login.component.scss']
})
export class OutletsComponent implements OnInit {
    
    Outlet= new AcquirerOutlet()
    ngOnInit() {
        window.scrollTo(0, 0);
        this.getOutlets();
    }
    constructor(private valuetypesService: ValueTypeService) { }

    getOutlets() {
        this.valuetypesService.getOutlets()
          .subscribe(data => {
            this.Outlet = JSON.parse(JSON.stringify(data));
          });
      }
}


// WEBPACK FOOTER //
// ./src/app/components/customer-pre-login/outlets/outlets.component.ts